import styled from 'styled-components'

export const LeagueHeader = styled.div`
    height:55px ;
    border-bottom: 3px solid #fff;
    font-size: 20px;
    display:flex;
    flex-direction:row;
    cursor: pointer;

    :hover{
        background-color: rgba(105, 105, 105, 0.18);
    }
`;